<template>
  <div>
    <Header modeType="1" />
    <div class="content-center">
      <div class="banner">
        <div class="content">
          <div class="banner-title">千橙RPA工具箱</div>
          <div class="line" />
          <div class="desc">
            RPA是指机器人流程自动化，就是让它们去做有规律的重复流程。
            <!-- <div class="desc-content">为企业提供业务员外勤管理、销售管理、订单管理、佣金管理、客户管理等销售辅助功能，全面提升销售业绩；基于企业微信，无缝对接企业商城、ERP、WMS、OMS等企业管理系统，构建全链路全闭环的数字化业务体系。</div> -->
          </div>
          <div class="btn-wrap">
            <!-- <div
                class="btn1"
                @click="openModal"
              >免费试用</div> -->
            <div class="btn" @click="openModal">立即咨询</div>
          </div>
        </div>
      </div>
      
      <div class="improve1 " style="height:524px;">
          <div class="sk-block-title1">
              <div class="title1">模拟人实现各种自动化操作 ，释放各种有逻辑规则 、重复性的人工工作</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content1">
  
          </div>
      </div>
      <div class="improve" style="height:727px;">
        <div class="sk-block-title1">
              <div class="title1">提供<span style="color:#3986ff;">6</span>大场景，<span style="color:#3986ff;">25+</span>流程应用，辅助自动化运营，提升运营效率，<br>降低人为失误</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content1">
  
          </div>
      </div>
      <div class="operate">
        <div class="sk-block-title1">
              <div class="title1">操作步骤少，效率提升大</div>
          </div>
          <div class="content">
            <div class="box_left">
                <p class="box_left_title">操作步骤</p>
                <div class="operate_box">
                    <div class="operate_left">
                        <div :class="tooItem=='1'?'left_icon1':'left_icon'">01</div>
                        <div class="left_icon3" v-if="tooItem == '1'"></div>
                        <div :class="tooItem=='2'?'left_icon1':'left_icon'">02</div>
                        <div class="left_icon3" v-if="tooItem == '2'"></div>
                        <div :class="tooItem=='3'?'left_icon1':'left_icon'">03</div>
                        <div class="left_icon3" v-if="tooItem == '3'"></div>
                        <div :class="tooItem=='4'?'left_icon1':'left_icon'">04</div>
                    </div>
                    <div class="operate_right">
                        <div class="right_text" @click="checkBg('1')" v-if="tooItem != '1'">准备数据</div>
                        <div class="right_text1" v-if="tooItem == '1'">
                            <div class="box_title">准备数据</div>
                            <div class="box_text">
                                <div class="text_line"></div>
                                <div class="text_right">准备需要执行的数据</div>
                            </div>
                        </div>
                        <div class="right_text" @click="checkBg('2')" v-if="tooItem != '2'">流程配置</div>
                        <div class="right_text1" v-if="tooItem == '2'">
                            <div class="box_title">流程配置</div>
                            <div class="box_text">
                                <div class="text_line"></div>
                                <div class="text_right">填写配置信息</div>
                            </div>
                        </div>
                        <div class="right_text" @click="checkBg('3')" v-if="tooItem != '3'">自动化执行</div>
                        <div class="right_text1" v-if="tooItem == '3'">
                            <div class="box_title">自动化执行</div>
                            <div class="box_text">
                                <div class="text_line"></div>
                                <div class="text_right">系统自动化</div>
                            </div>
                        </div>
                        <div class="right_text" @click="checkBg('4')" v-if="tooItem != '4'">结果反馈</div>
                        <div class="right_text1" v-if="tooItem == '4'">
                            <div class="box_title">结果反馈</div>
                            <div class="box_text">
                                <div class="text_line"></div>
                                <div class="text_right">反馈执行数据</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box_right">
                <img v-if="tooItem == '1'" src="@/assets/images/QcTool/right1.png" alt="" />
                <img style="width: 747px;height: 413px;" v-if="tooItem == '2'" src="@/assets/images/QcTool/right2.png" alt="" />
                <img style="width: 747px;height: 395px;" v-if="tooItem == '3'" src="@/assets/images/QcTool/right3.png" alt="" />
                <img style="width: 747px;height: 392px;" v-if="tooItem == '4'" src="@/assets/images/QcTool/right4.png" alt="" />
            </div>
          </div>
      </div>
      <div class="custom">
      <div class="sk-block-title1">
        <div class="title1">案例</div>
      </div>
      <div class="content">
        <el-carousel :autoplay="false" :interval="5000" arrow="always">
            <el-carousel-item >
            <div class="custom_item">
              <img src="@/assets/images/QcTool/custom_bg1.png" alt="">
            </div>
          </el-carousel-item>
          <el-carousel-item >
            <div class="custom_item">
              <img src="@/assets/images/QcTool/custom_bg2.png" alt="">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
      <Contact :infoSources="'汇通数科官网-千橙RPA工具箱'" />
      <TryModal
        v-if="visible"
        :visible="visible"
        info-sources="社群分销"
        @cancel="modalClose"
      />
    </div>
    <Footer />
  </div>
  </template>
  
  <script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import metaInfo from "@/common/util/metaInfo";
  import TryModal from "@/components/TryModal";
  import Contact from "@/components/Contact";

  export default {
    metaInfo: metaInfo.QcTool,
    components: {
      Header,
      Footer,
      TryModal,
      Contact,
    },
    data() {
      return {
        visible: false,
        toolBg: require("@/assets/images/QcCashier/tool1.png"),
        tooItem: "1",
      };
    },
    mounted() {},
    methods: {
      checkBg(item) {
        this.tooItem = item;
        this.toolBg = "@/assets/images/QcCashier/tool" + item + ".png";
      },
      openModal: function () {
        this.visible = true;
      },
      modalClose: function (data) {
        this.visible = data;
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .operate{
    height:724px;
    background: #F7F8FD;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items:center;
      position: relative;
      .content{
          margin-top:53px;
          width: 1200px;
          height:544px;
          display: flex;
            flex-direction: row;
            justify-content: center;
            align-items:center;
            .box_left{
                width: 369px;
                height:544px;
                background: url("~@/assets/images/QcTool/content_banner.png") no-repeat;
                background-size: 369px 544px;
                padding: 21px 0 0 18px;
                .box_left_title{
                    height:50px;
                }
                p{
                    height: 28px;
                    font-size: 20px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                    line-height: 28px;
                    text-align: left;
                }
                .operate_box{
                    width: 100%;
                    height:100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    .operate_left{
                        width: 70px;
                        height:100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        .left_icon{
                            height:47px;
                            width: 47px;
                            line-height:40px;
                            font-size: 16px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 500;
                            color: #FFFFFF;
                            background: url("~@/assets/images/QcTool/icon1.png") no-repeat center;
                            background-size: 39px 47px;
                            margin-bottom: 56px;
                        }
                        .left_icon1{
                            height:58px;
                            width: 49px;
                            line-height:47px;
                            font-size: 20px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 500;
                            color: #FFFFFF;
                            background: url("~@/assets/images/QcTool/icon2.png") no-repeat center;
                            background-size: 49px 58px;
                            margin-bottom:13px;
                        }
                        .left_icon3{
                            width: 23px;
                            height:63px;
                            background: url("~@/assets/images/QcTool/icon3.png") no-repeat center;
                            background-size: 23px 63px;
                            margin-bottom:12px;
                        }
                    }
                    .operate_right{
                        width: 276px;
                        height:100%;
                        .right_text{
                            text-align: left;
                            padding-left: 21px;
                            height: 33px;
                            font-size: 24px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 600;
                            color: #333333;
                            line-height: 33px;
                            margin-bottom: 65px;
                            cursor: pointer;
                        }
                        .right_text1{
                            padding-left: 21px;
                            width: 276px;
                            height: 126px;
                            background: #FFFFFF;
                            border-radius: 20px 1px 1px 20px;
                            display: flex;
                            flex-direction: column;
                            align-items: start;
                            justify-content: space-evenly;
                            margin-bottom: 52px;
                            cursor: pointer;
                            .box_title{
                                height: 33px;
                                font-size: 24px;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 600;
                                color: #3986FF;
                                line-height: 33px;
                            }
                            .box_text{
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                justify-content: start;
                                .text_line{
                                    width: 4px;
                                    height: 14px;
                                    background: linear-gradient(360deg, #6BBBFF 0%, #3986FF 100%);
                                    border-radius: 2px;
                                }
                                .text_right{
                                    font-size: 20px;
                                    font-family: PingFangSC, PingFang SC;
                                    font-weight: 400;
                                    color: #333333;
                                    line-height: 28px;
                                    margin-left: 7px;
                                }
                            }
                        }
                    }
                }
            }
            .box_right{
                width: 831px;
                height:544px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                img{
                    width: 698px;
                    height:457px;
                }
            }
      }
  }
  .programme{
        height:1047px;
        background: #F4F5FB;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items:center;
      position: relative;
      .content{
          margin-top:49px;
          width: 1200px;
          height:834px;
          background: url("~@/assets/images/QcMarketing/content9.png") no-repeat;
          background-size: 1200px 834px;
      }
  }
  .improve1{
    background: #F9FFFF;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items:center;
      position: relative;
      .content1{
          margin-top:55px;
          width: 1200px;
          height:360px;
          background: url("~@/assets/images/QcTool/content1.png") no-repeat;
          background-size: 1200px 320px;
      }
  }
  .improve{
      display: flex;
      flex-direction: column;
      // justify-content: center;
    background: #FFFFFF;
      align-items:center;
      .content1{
          margin-top:14px;
          width: 1200px;
          height:521px;
          background: url("~@/assets/images/QcTool/content2.png") no-repeat center;
          background-size: 1200px 521px;
      }
  }
  
  /deep/ i.el-icon-arrow-left {
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ i.el-icon-arrow-right{
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--left,button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  
  .custom{
    height:769px;
        background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items:center;
    .content{
        width: 1200px;
        height:570px;
        margin: 0 auto;
        // padding: 53px 0;
        text-align: left;
        background: rgba(255,255,255,.5);
        // background: #FFFFFF;
        // opacity: 0.55;
        // border-radius: 8px;
        margin-top: 35px;
        /deep/ .el-carousel__container {
            position: relative;
            height: 570px;
        }
        .custom_item{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            // padding:0 150px;
            img{
                width: 1200px;
                height: 570px;
            }
        }
    }
}
  .case{
      background: #F8FBFF;
      .content{
          width: 1200px;
          margin: 0 auto;
          padding: 53px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
              width: 1171px;
              height:397px;
          }
      }
  }
  
    .banner {
      background: url("~@/assets/images/QcTool/banner.png") no-repeat center;
      background-size: 100% 100%;
      min-width: 1200px;
      min-height:420px;
      .content {
        width: 1200px;
        margin: 0 auto;
        padding: 53px 0;
        text-align: left;
        .banner-title {
          font-size: 48px;
          color: #FFFFFF;
          line-height: 55px;
        }
        .line {
          width: 100px;
          height: 6px;
          background: #28DAFB;
          margin: 16px 0 31px;
        }
        .desc {
            width: 484px;
            height: 84px;
            font-size: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 28px;
          .desc-content{
              width: 600px;
              height: 96px;
              font-size: 16px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 32px;
          }
        }
        .btn-wrap {
          display: flex;
          .btn {
            width: 200px;
            height: 58px;
            line-height: 58px;
            border-radius: 6px;
            border: 1px solid #FFFFFF;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
            // margin-left:20px;
          }
          .btn1 {
            width: 200px;
            height: 58px;
            line-height: 58px;
            background: #3986FF;
            border-radius: 6px;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
          //   margin-left:20px;
          }
        }
      
    }
  
  }
  </style>
  